import { render, staticRenderFns } from "./ProfilePictureEdit.vue?vue&type=template&id=39e1e124&scoped=true&"
import script from "./ProfilePictureEdit.vue?vue&type=script&lang=ts&"
export * from "./ProfilePictureEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ProfilePictureEdit.vue?vue&type=style&index=0&id=39e1e124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e1e124",
  null
  
)

export default component.exports